import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import '@/core/i18n/i18n';
import { App } from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in the DOM.');
}

createRoot(rootElement).render(
  <StrictMode>
    <Suspense fallback={<div>Cargando...</div>}>
      <App />
    </Suspense>
  </StrictMode>,
);
